var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdentity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_2153_16692)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7917 42.75C19.7917 42.75 17.75 42.75 17.75 40.7083C17.75 38.6667 19.7917 32.5417 30 32.5417C40.2083 32.5417 42.25 38.6667 42.25 40.7083C42.25 42.75 40.2083 42.75 40.2083 42.75H19.7917ZM30 30.5C31.6245 30.5 33.1824 29.8547 34.331 28.706C35.4797 27.5574 36.125 25.9995 36.125 24.375C36.125 22.7505 35.4797 21.1926 34.331 20.044C33.1824 18.8953 31.6245 18.25 30 18.25C28.3755 18.25 26.8176 18.8953 25.669 20.044C24.5203 21.1926 23.875 22.7505 23.875 24.375C23.875 25.9995 24.5203 27.5574 25.669 28.706C26.8176 29.8547 28.3755 30.5 30 30.5V30.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2153_16692",
    x1: 8,
    y1: 8.5,
    x2: 45.5,
    y2: 55.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2175C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4199FB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/identity.d644110f44b7f13058a5abf73e8a06fc.svg";
export { ForwardRef as ReactComponent };